import { render, staticRenderFns } from "./addusersdetails.vue?vue&type=template&id=9ef94614"
import script from "./addusersdetails.vue?vue&type=script&lang=js"
export * from "./addusersdetails.vue?vue&type=script&lang=js"
import style0 from "./addusersdetails.vue?vue&type=style&index=0&id=9ef94614&prod&lang=css"
import style1 from "./addusersdetails.vue?vue&type=style&index=1&id=9ef94614&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports